import { Component, ReactNode } from 'react';

import {
  handleChunkLoadError,
  isChunkLoadError,
} from 'src/utils/chunkErrorHandler';

interface Props {
  children: ReactNode;
}

interface State {
  hasChunkError: boolean;
}

export default class ChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasChunkError: false };
  }

  static getDerivedStateFromError(error: Error): State | null {
    if (isChunkLoadError(error)) {
      return { hasChunkError: true };
    }
    return null;
  }

  componentDidCatch(error: Error): void {
    if (isChunkLoadError(error)) {
      handleChunkLoadError();
    }
  }

  render(): ReactNode {
    if (this.state.hasChunkError) {
      // return null while reloading
      return null;
    }

    return this.props.children;
  }
}
